export const getShareData = ({ year, make, model, visitorId, isMobile }) => {
  if (typeof window === 'undefined') return null;

  const urlObj = new URL(window.location.pathname, window.location.origin);
  urlObj.searchParams.set('utm_source', 'edmunds');
  urlObj.searchParams.set('utm_medium', 'vdp_share');
  urlObj.searchParams.set('utm_device', isMobile ? 'mobile' : 'desktop');
  if (visitorId) {
    urlObj.searchParams.set('utm_targetId', visitorId);
  }

  return {
    title: `Check out this ${year} ${make} ${model} I found on Edmunds`,
    text: `Check out this ${year} ${make} ${model} I found on Edmunds`,
    url: urlObj.toString(),
  };
};
